import React from 'react';
import styled from 'styled-components';

import { ThemeContext } from './ThemeContext';
import Icon from './icons';

const StyledIconWrapper = styled.label`
  padding: 0.2rem;
  position: fixed;
  top: 1rem;
  right: 1rem;

  @media (max-width: 768px) {
    top: 0.5rem;
    right: 0.5rem;
    position: absolute;
  }
  svg {
    width: 26px;
    height: auto;
    fill: var(--color-text);
  }
  &:hover,
  &:focus {
    cursor: pointer;
    svg {
      fill: var(--color-primary);
    }
  }
`;

const DarkToggle = () => {
  const { colorMode, setColorMode } = React.useContext(ThemeContext);

  if (!colorMode) {
    return null;
  }

  return (
    <StyledIconWrapper
      onClick={() => {
        setColorMode(colorMode === 'light' ? 'dark' : 'light');
      }}
    >
      <Icon iconName={colorMode} />
    </StyledIconWrapper>
  );
};

export default DarkToggle;
